export default [
    {
        page: 2,
        label: 'Message from the Commissioner',
    },
    {
        page: 3,
        label: 'Contents',
    },
    {
        page: 6,
        label: "What's New",
    },
    {
        page: 7,
        items: [
            {
                page: 7,
                label: 'Do You Have To File?',
            },
            {
                page: 7,
                items: [
                    {
                        page: 7,
                        label: 'What if You Cannot File on Time?',
                    },
                    {
                        page: 7,
                        label: 'Private Delivery Services',
                    },
                ],
                label: 'When and Where Should You File?',
            },
        ],
        label: 'Filing Requirements',
    },
    {
        page: 12,
        items: [
            {
                page: 12,
                items: [
                    {
                        page: 12,
                        label: 'Name Change',
                    },
                    {
                        page: 12,
                        label: 'Address Change',
                    },
                    {
                        page: 12,
                        label: 'P.O. Box',
                    },
                    {
                        page: 12,
                        label: 'Foreign Address',
                    },
                    {
                        page: 12,
                        label: 'Death of a Taxpayer',
                    },
                ],
                label: 'Name and Address',
            },
            {
                page: 12,
                items: [
                    {
                        page: 12,
                        label: 'IRS Individual Taxpayer Identification Numbers (ITINs) for Aliens',
                    },
                    {
                        page: 12,
                        label: 'Nonresident Alien Spouse',
                    },
                ],
                label: 'Social Security Number (SSN)',
            },
            {
                page: 12,
                label: 'Presidential Election Campaign Fund',
            },
            {
                page: 12,
                items: [
                    {
                        page: 12,
                        label: 'Line 1',
                    },
                    {
                        page: 12,
                        label: 'Line 2',
                    },
                    {
                        page: 13,
                        label: 'Line 3',
                    },
                    {
                        page: 13,
                        label: 'Line 4',
                    },
                    {
                        page: 14,
                        label: 'Line 5',
                    },
                ],
                label: 'Filing Status',
            },
            {
                page: 14,
                items: [
                    {
                        page: 14,
                        label: 'Line 6b',
                    },
                ],
                label: 'Exemptions',
            },
            {
                page: 15,
                items: [
                    {
                        page: 15,
                        label: ' Dependents and Qualifying Child for Child Tax Credit ',
                    },
                ],
                label: 'Line 6c—Dependents',
            },
            {
                page: 16,
                label: ' Definitions and Special Rules ',
            },
            {
                page: 19,
                items: [
                    {
                        page: 19,
                        label: 'Foreign-Source Income',
                    },
                    {
                        page: 19,
                        label: 'Chapter 11 Bankruptcy Cases',
                    },
                    {
                        page: 19,
                        label: 'Community Property States',
                    },
                    {
                        page: 19,
                        label: 'Rounding Off to Whole Dollars',
                    },
                    {
                        page: 19,
                        label: 'Line 7',
                    },
                    {
                        page: 20,
                        label: 'Line 8a',
                    },
                    {
                        page: 20,
                        label: 'Line 8b',
                    },
                    {
                        page: 20,
                        label: 'Line 9a',
                    },
                    {
                        page: 20,
                        label: 'Line 9b',
                    },
                    {
                        page: 21,
                        label: 'Line 10',
                    },
                    {
                        page: 22,
                        label: 'Line 11',
                    },
                    {
                        page: 22,
                        label: 'Line 12',
                    },
                    {
                        page: 22,
                        label: 'Line 13',
                    },
                    {
                        page: 22,
                        label: 'Line 14',
                    },
                    {
                        page: 22,
                        label: 'Lines 15a and 15b',
                    },
                    {
                        page: 23,
                        label: 'Lines 16a and 16b',
                    },
                    {
                        page: 25,
                        label: 'Line 19',
                    },
                    {
                        page: 25,
                        label: 'Lines 20a and 20b',
                    },
                    {
                        page: 27,
                        label: 'Line 21',
                    },
                ],
                label: 'Income',
            },
            {
                page: 28,
                items: [
                    {
                        page: 28,
                        label: 'Line 23',
                    },
                    {
                        page: 28,
                        label: 'Line 24',
                    },
                    {
                        page: 28,
                        label: 'Line 25',
                    },
                    {
                        page: 28,
                        label: 'Line 26',
                    },
                    {
                        page: 28,
                        label: 'Line 27',
                    },
                    {
                        page: 28,
                        label: 'Line 28',
                    },
                    {
                        page: 28,
                        label: 'Line 29',
                    },
                    {
                        page: 29,
                        label: 'Line 30',
                    },
                    {
                        page: 29,
                        label: 'Lines 31a and 31b',
                    },
                    {
                        page: 29,
                        label: 'Line 32',
                    },
                    {
                        page: 32,
                        label: 'Line 33',
                    },
                    {
                        page: 33,
                        label: 'Line 34',
                    },
                    {
                        page: 33,
                        label: 'Line 35',
                    },
                    {
                        page: 33,
                        label: 'Line 36',
                    },
                    {
                        page: 33,
                        label: 'Line 37',
                    },
                ],
                label: 'Adjusted Gross Income',
            },
            {
                page: 33,
                items: [
                    {
                        page: 33,
                        label: 'Line 39a',
                    },
                    {
                        page: 33,
                        label: 'Line 39b',
                    },
                    {
                        page: 33,
                        label: 'Line 40',
                    },
                    {
                        page: 35,
                        label: 'Line 44',
                    },
                    {
                        page: 38,
                        label: 'Line 45',
                    },
                    {
                        page: 38,
                        label: 'Line 47',
                    },
                    {
                        page: 38,
                        label: 'Line 48',
                    },
                    {
                        page: 38,
                        label: 'Line 49',
                    },
                    {
                        page: 38,
                        label: 'Line 50',
                    },
                    {
                        page: 39,
                        label: ' ',
                    },
                    {
                        page: 42,
                        label: 'Line 52',
                    },
                    {
                        page: 42,
                        label: 'Line 53',
                    },
                ],
                label: 'Tax and Credits',
            },
            {
                page: 42,
                items: [
                    {
                        page: 42,
                        label: 'Line 57',
                    },
                    {
                        page: 42,
                        label: 'Line 58',
                    },
                    {
                        page: 43,
                        label: 'Line 59a',
                    },
                    {
                        page: 43,
                        label: 'Line 59b',
                    },
                    {
                        page: 43,
                        label: 'Line 60',
                    },
                    {
                        page: 44,
                        label: 'Line 61',
                    },
                ],
                label: 'Other Taxes',
            },
            {
                page: 44,
                items: [
                    {
                        page: 44,
                        label: 'Line 62',
                    },
                    {
                        page: 44,
                        label: 'Line 63',
                    },
                    {
                        page: 45,
                        label: 'Lines 64a and 64b— Earned Income Credit (EIC)',
                    },
                    {
                        page: 47,
                        label: ' Definitions and Special Rules ',
                    },
                    {
                        page: 33,
                        label: 'Line 65',
                    },
                    {
                        page: 33,
                        label: 'Line 66',
                    },
                    {
                        page: 33,
                        label: 'Line 67',
                    },
                    {
                        page: 33,
                        label: 'Line 68',
                    },
                    {
                        page: 33,
                        label: 'Line 69',
                    },
                    {
                        page: 33,
                        label: 'Line 70',
                    },
                    {
                        page: 33,
                        label: 'Line 71',
                    },
                ],
                label: 'Payments',
            },
            {
                page: 33,
                items: [
                    {
                        page: 33,
                        label: 'Line 73',
                    },
                    {
                        page: 33,
                        label: 'Lines 74a Through 74d',
                    },
                    {
                        page: 34,
                        label: 'Line 75',
                    },
                ],
                label: 'Refund',
            },
            {
                page: 34,
                items: [
                    {
                        page: 34,
                        label: 'Line 76',
                    },
                    {
                        page: 34,
                        label: 'Line 77',
                    },
                ],
                label: 'Amount You Owe',
            },
            {
                page: 35,
                label: 'Third Party Designee',
            },
            {
                page: 35,
                items: [
                    {
                        page: 35,
                        label: "Child's Return",
                    },
                    {
                        page: 35,
                        label: 'Daytime Phone Number',
                    },
                    {
                        page: 35,
                        label: 'Electronic Return Signatures!',
                    },
                ],
                label: 'Sign Your Return',
            },
            {
                page: 36,
                label: 'Identity Protection PIN',
            },
            {
                page: 36,
                label: 'Paid Preparer Must Sign Your Return',
            },
            {
                page: 36,
                label: 'Assemble Your Return',
            },
        ],
        label: 'Line Instructions for Form 1040',
    },
    {
        page: 41,
        items: [
            {
                page: 41,
                label: 'How To Avoid Common Mistakes',
            },
            {
                page: 41,
                label: 'What Are Your Rights as a Taxpayer?',
            },
            {
                page: 41,
                label: 'Innocent Spouse Relief',
            },
            {
                page: 41,
                label: 'Income Tax Withholding and Estimated Tax Payments for 2012',
            },
            {
                page: 41,
                label: 'Secure Your Tax Records from Identity Theft',
            },
            {
                page: 42,
                label: 'How Do You Make a Gift To Reduce Debt Held By the Public?',
            },
            {
                page: 42,
                label: 'How Long Should Records Be Kept?',
            },
            {
                page: 42,
                label: 'Amended Return',
            },
            {
                page: 42,
                label: 'Need a Copy of Your Tax Return?',
            },
            {
                page: 42,
                items: [
                    {
                        page: 42,
                        label: 'Claiming a Refund for a Deceased Taxpayer',
                    },
                ],
                label: 'Death of a Taxpayer',
            },
            {
                page: 42,
                label: 'Past Due Returns',
            },
            {
                page: 42,
                items: [
                    {
                        page: 42,
                        label: 'Send Your Written Tax Questions to the IRS',
                    },
                    {
                        page: 42,
                        label: 'Research Your Tax Questions Online',
                    },
                    {
                        page: 42,
                        label: 'Free Tax Return Assistance',
                    },
                    {
                        page: 43,
                        label: 'Everyday Tax Solutions',
                    },
                    {
                        page: 43,
                        label: 'IRS Videos',
                    },
                    {
                        page: 43,
                        label: 'Help for People With Disabilities',
                    },
                    {
                        page: 43,
                        label: 'Tax Services in Other Languages',
                    },
                ],
                label: 'Other Ways To Get Help',
            },
            {
                page: 43,
                items: [
                    {
                        page: 43,
                        label: 'Interest',
                    },
                    {
                        page: 43,
                        label: 'Penalties',
                    },
                ],
                label: 'Interest and Penalties',
            },
        ],
        label: 'General Information',
    },
    {
        page: 44,
        label: 'Refund Information',
    },
    {
        page: 44,
        items: [
            {
                page: 44,
                label: 'Recorded Tax Information',
            },
            {
                page: 44,
                label: 'Topics by Internet',
            },
        ],
        label: 'What Is TeleTax?',
    },
    {
        page: 44,
        label: 'TeleTax Topics',
    },
    {
        page: 45,
        items: [
            {
                page: 45,
                label: 'Before You Call',
            },
            {
                page: 45,
                label: 'Making the Call',
            },
            {
                page: 45,
                label: 'Before You Hang Up',
            },
        ],
        label: 'Calling the IRS',
    },
    {
        page: 46,
        items: [
            {
                page: 46,
                label: 'We Welcome Comments on Forms',
            },
            {
                page: 46,
                label: 'Estimates of Taxpayer Burden',
            },
            {
                page: 47,
                label: 'How To Use the Order Form',
            },
            {
                page: 47,
                label: 'Mail Your Order Form To:',
            },
            {
                page: 47,
                label: 'Footnotes for Certain Federal Outlays',
            },
        ],
        label: 'Quick and Easy Access to Tax Help and Tax Forms and Publications',
    },
    {
        page: 47,
        label: 'Index to Instructions',
    },
    {
        page: 48,
        label: 'Where Do You File?',
    },
];
